<template>
<div>

  <div v-show="errorText !== ''" v-html="errorText" class="alert alert-danger" role="alert">
    {{errorText}}
  </div>
  <div v-show="success" class="alert alert-success" role="alert">
    Los precios fueron cambiados con éxito
  </div>

  <b-modal header-bg-variant="primary" centered ref="processCSVModal" id="processCSVModal" size="lg" title="Guardar los cambios de precio" o-close-on-backdrop="true" @ok="processAltaPrecios" cancel-title="Cancelar">
    ¿Desea guardar los cambios de precios seleccionados?
  </b-modal>
  <h4>Actualización masiva de precios</h4>
  <b-row class="my-3">
    <b-col md="12">
      <b-button
        :disabled="!Boolean(csvPricesFile) || errorText !== ''"
        v-on:click="showProcessConfirm"
        variant="primary"
        class="float-right mr-2">Procesar</b-button>
      <b-button
        @click="downloadPriceFile"
        variant="primary"
        class="float-right mr-2">Obtener listado actual de precios CSV</b-button>
    </b-col>
  </b-row>
  <moon-loader :loading="inProgress" color="#000" size="30px"></moon-loader>
  <b-tabs v-model="tabIndex">
    <b-tab title="Seleccione un archivo" active>
      <h5>Subir archivo CSV a procesar</h5>
      <p v-show="!Boolean(csvPricesFile)" class="alert alert-warning"><i class="fa fa-exclamation-triangle"></i>Se debe seleccionar un CSV para continuar.</p>
      <p v-show="Boolean(csvPricesFile)">Archivo CSV seleccionado: <strong>{{csvPricesFile && csvPricesFile.name}}</strong></p>
      <b-row class="mb-2">
        <b-col md="6">
          <b-form-file id="csvPricesFile"
            ref="filePricestInput"
            :no-drop="true"
            @click.native="$refs.filePricestInput.reset()"
            accept=".csv"
            v-on:change="onFileChanged"
            v-model="csvPricesFile"
            placeholder="Lista Precios CSV"></b-form-file>
        </b-col>
      </b-row>
    </b-tab>
    <b-tab title="Previsualización de datos" :disabled="!Boolean(csvPricesFile)">
      <b-row class="mt-3">
        <b-col class="col-md-auto">
          <b-pagination :total-rows="productsCount" :per-page="perPage" v-model="currentPage" class="mb-3" />
        </b-col>
        <b-col class="col-md-auto per-page">
          <b-form-group id="perPage" horizontal label="Mostrar por página">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-card header-bg-variant="primary" border-variant="primary" header="Previsualizacion">
            <h5>Previsualización de precios a actualizar</h5>
            <p>Cantidad de Precios: <strong>{{productsCount}}</strong></p>
            <div class="w-100 overflow-x-auto">
              <b-table
                ref="productsTable"
                :items="itemProvider"
                :current-page="currentPage"
                :per-page="perPage"
                hover
                :fields="csvFields"
                :small="true"
                show-empty
                striped
                empty-text="No hay precios para mostrar"
                hover
                stacked="lg"
                foot-clone>
              </b-table>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-tab>
  </b-tabs>
</div>
</template>

<script>
import appConfig from '@/config/applicationConfig.js'
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import {ProductServiceMixim} from '@/mixims/ProductServiceMixim.js'
import {ValidationsMixim} from '@/mixims/ValidationsMixim.js'
import Papa from 'papaparse'

export default {
  components: {
    MoonLoader
  },
  mixins: [ProductServiceMixim, ValidationsMixim],
  methods: {
    resetCSVPricesFile () {
      this.$refs.filePricestInput.reset()
    },
    itemProvider (tableComponentInfo) {
      let start = (tableComponentInfo.currentPage - 1) * tableComponentInfo.perPage
      let end = tableComponentInfo.perPage * tableComponentInfo.currentPage
      return this.csvElements.slice(start, end)
    },
    showProcessConfirm () {
      this.$refs.processCSVModal.show()
    },
    processAltaPrecios () {
      this.uploadPricesFile()
    },
    downloadPriceFile () {
      this.errorText = ''
      this.getShippingRatesPriceList().then(
        (csvFile) => {
          let headers = csvFile.headers
          var blob = new Blob([csvFile.body], {
            type: { type: headers.map['content-type'] }
          })
          const blobURL = window.URL.createObjectURL(blob)
          const tempLink = document.createElement('a')
          tempLink.style.display = 'none'
          tempLink.href = blobURL
          tempLink.setAttribute('download', 'shippingRatesPriceList.csv')
          document.body.appendChild(tempLink)
          tempLink.click()
          document.body.removeChild(tempLink)
        },
        () => {
          this.errorText = 'Error procesando la descarga'
        }
      )
    },
    uploadPricesFile () {
      this.inProgress = true
      this.success = false
      this.errorText = ''
      let formData = new FormData()
      formData.append('file', this.csvPricesFile)
      this.uploadCsvShippingRatesPriceList(formData, this.delimiter).then(
        () => {
          this.inProgress = false
          this.success = true
        },
        (error) => {
          this.inProgress = false
          this.errorText = error.body.message || `Error procesando el archivo CSV - ${this.csvPricesFile.name}`
          /* Mark every row as error */
          this.csvElements.forEach((elem, index) => {
            elem._rowVariant = 'danger'
          })
          this.$refs.productsTable.refresh()
        }
      )
    },
    onFileAttrChanged (evt) {
      this.errorText = ''
      this.success = false
    },
    /* On price csv file changed */
    onFileChanged (evt) {
      const self = this
      this.errorText = ''
      this.success = false
      this.csvElements = []
      self.$refs.productsTable.refresh()
      var file = evt.target.files[0]
      if (!file) {
        return
      }

      var reader = new FileReader()

      /* Parse the file */
      reader.onload = (evt) => {
        try {
          self.tabIndex = 1
          let rowError = false
          let parsedData = Papa.parse(
            evt.target.result.trim(),
            {
              delimiter: '',
              skipEmptyLines: true,
              encoding: 'ISO-8859-1'
            }
          )

          if (parsedData.errors.length > 0) {
            self.errorText = `El archivo tiene un formato que no es soportado`
            self.$refs.fileProductInput.reset()
            return
          }

          self.delimiter = parsedData.meta.delimiter

          let header = parsedData.data.shift()
          if (header.length !== 13) {
            self.errorText += 'La cabecera del archivo CSV debe tener 13 columnas.'
            self.errorText += '<ul>'
            self.errorText += '<li>Verificar que la cabecera es "Id","Código postal desde", "Código postal hasta", "Peso desde", "Peso hasta", "Precio","Valor adicional (% del valor del producto)", "Valor adicional por peso", "Volumen máximo", "Plazo de entrega", "País", "Transportadora", "Códigos Postales"</li>'
            self.errorText += '</ul>'

            return
          }

          // VALIDACIÓN: Verificar si el archivo está vacío (solo tiene cabecera)
          if (parsedData.data.length === 0) {
            self.errorText = 'El archivo CSV está vacío. Debe contener al menos un precio para procesar.'
            self.$refs.filePricestInput.reset()
            self.csvPricesFile = null
            self.tabIndex = 0
            return
          }

          this.productsCount = parsedData.data.length
          parsedData.data.forEach((elem, index) => {
            let newRowElem = {
              'id': elem[0],
              'zcFrom': elem[1],
              'zcTO': elem[2],
              'weightFrom': elem[3],
              'weightTo': elem[4],
              'price': elem[5],
              'addicionalValue': elem[6],
              'weightaddicionalValue': elem[7],
              'maxVolume': elem[8],
              'deliveryWindow': elem[9],
              'country': elem[10],
              'carrier': elem[11],
              'zcCommas': elem[12],
              '_cellVariants': null
            }
            if (elem.length !== 13) {
              rowError = true
              newRowElem = {'_cellVariants': null}
              newRowElem.sku = `Faltan ${13 - elem.length} campos`
            } else {
              newRowElem._cellVariants = {}
              let hasEmptyFields = this.testEmptyFields(elem, newRowElem)

              rowError = hasEmptyFields || this.testZipCodes(elem[1], elem[2], elem[12], newRowElem) ||
                this.testPrices(elem[5], elem[6], elem[7], newRowElem) ||
                this.testWeight(elem[3], elem[4], newRowElem) ||
                !this.isValidInteger(elem[8]) ||
                !this.isValidInteger(elem[9]) ||
                (this.isValidInteger(elem[9]) && elem[9] > 5) ||
                this.testCountry(elem[10], newRowElem) ||
                this.testCarrier(elem[11], newRowElem)
            }
            if (rowError) {
              self.errorText = 'Hay filas con errores en el archivo CSV'
              self.errorText += '<ul>'
              self.errorText += '<li>Verifique que las filas tengan 13 items igual que la cabecera.</li>'
              self.errorText += '<li>Verifique que las fechas tengan formtato YYYY-MM-DD.</li>'
              self.errorText += '<li>Verifique que los precios sean números válidos.</li>'
              if (this.testCarrier(elem[11], newRowElem)) {
                self.errorText += '<li>Verifique que las transportadoras sean válidas.</li>'
              }
              if (this.isValidInteger(elem[9]) && elem[9] > 5) {
                newRowElem._cellVariants.deliveryWindow = 'danger'
                self.errorText += '<li>Verifique que el plazo de entrega no sea mayor a 5.</li>'
              }
              if (!this.isValidInteger(elem[9])) {
                newRowElem._cellVariants.deliveryWindow = 'danger'
                self.errorText += '<li>Verifique que el plazo de entrega sea un numéro válido.</li>'
              }
              self.errorText += '</ul>'

              if (newRowElem._cellVariants === null) {
                newRowElem._rowVariant = 'danger'
              }
            } else {
              newRowElem._rowVariant = 'success'
            }
            self.csvElements.push(newRowElem)
          })
          this.$refs.productsTable.refresh()
        } catch (err) {
          console.log(err)
          this.errorText = 'El archivo CSV de precios tiene fallas'
        }
      }
      reader.readAsText(file, 'ISO-8859-1')
    },
    testEmptyFields (elem, newRowElem) {
      let hasError = false

      // Validar Id (elem[0])
      if (!elem[0] || elem[0].trim() === '') {
        newRowElem._cellVariants.id = 'danger'
        hasError = true
      }

      // Validar que tenga códigos postales (rango O individuales)
      // Si no tiene rango (elem[1] y elem[2]), debe tener códigos individuales (elem[12])
      const hasRange = elem[1] && elem[1].trim() !== '' && elem[2] && elem[2].trim() !== ''
      const hasIndividual = elem[12] && elem[12].trim() !== ''

      if (!hasRange && !hasIndividual) {
        newRowElem._cellVariants.zcFrom = 'danger'
        newRowElem._cellVariants.zcTO = 'danger'
        newRowElem._cellVariants.zcCommas = 'danger'
        hasError = true
      }

      // Validar Peso desde (elem[3])
      if (!elem[3] || elem[3].trim() === '') {
        newRowElem._cellVariants.weightFrom = 'danger'
        hasError = true
      }

      // Validar Peso hasta (elem[4])
      if (!elem[4] || elem[4].trim() === '') {
        newRowElem._cellVariants.weightTo = 'danger'
        hasError = true
      }

      // Validar Precio (elem[5])
      if (!elem[5] || elem[5].trim() === '') {
        newRowElem._cellVariants.price = 'danger'
        hasError = true
      }

      // Validar Valor adicional % (elem[6])
      if (!elem[6] || elem[6].trim() === '') {
        newRowElem._cellVariants.addicionalValue = 'danger'
        hasError = true
      }

      // Validar Valor adicional por peso (elem[7])
      if (!elem[7] || elem[7].trim() === '') {
        newRowElem._cellVariants.weightaddicionalValue = 'danger'
        hasError = true
      }

      // Validar Volumen máximo (elem[8])
      if (!elem[8] || elem[8].trim() === '') {
        newRowElem._cellVariants.maxVolume = 'danger'
        hasError = true
      }

      // Validar Plazo de entrega (elem[9])
      if (!elem[9] || elem[9].trim() === '') {
        newRowElem._cellVariants.deliveryWindow = 'danger'
        hasError = true
      }

      // Validar País (elem[10])
      if (!elem[10] || elem[10].trim() === '') {
        newRowElem._cellVariants.country = 'danger'
        hasError = true
      }

      // Validar Transportadora (elem[11])
      if (!elem[11] || elem[11].trim() === '') {
        newRowElem._cellVariants.carrier = 'danger'
        hasError = true
      }

      return hasError
    },
    testCarrier (carrier, newRowElem) {
      let ret = true
      const isAdmin = this.$store.getters.isAdmin
      this.$store.getters.carriers.forEach((item, index) => {
        if (item.name === carrier && item.isActive) {
          ret = false
          if (item.isActive && item.type === 'ADMIN' && !isAdmin) {
            ret = true
          } else return false
        }
      })
      if (ret) {
        newRowElem._cellVariants.carrier = 'danger'
        return true
      }
      return false
    },
    testCountry (country, newRowElem) {
      let ret = true
      appConfig.COUNTRY_CODES.forEach((elem, index) => {
        if (elem.value === country) {
          ret = false
          return false
        }
      })
      if (ret) {
        newRowElem._cellVariants.country = 'danger'
        return true
      }
      return false
    },
    testZipCodes (zcFrom, zcTO, zcCommas, newRowElem) {
      let ret = false
      if (this.isValidCP(zcFrom) && this.isValidCP(zcTO)) {
        return false
      } else {
        let zips = zcCommas.split('|')
        zips.forEach((elem, index) => {
          if (!this.isValidCP(elem)) {
            ret = true
            return true
          }
        })
      }
      if (ret) {
        newRowElem._cellVariants.zcFrom = 'danger'
        newRowElem._cellVariants.zcTO = 'danger'
        newRowElem._cellVariants.zcCommas = 'danger'
        return true
      }
    },
    testWeight (weightFrom, weightTo, newRowElem) {
      if (!this.isValidFloat(weightFrom, true, false)) {
        newRowElem._cellVariants.weightTo = 'danger'
        return true
      }
      if (!this.isValidFloat(weightTo, true, false)) {
        newRowElem._cellVariants.weightTo = 'danger'
        return true
      }
      if (Number(weightTo) < Number(weightFrom)) {
        newRowElem._cellVariants.weightTo = 'danger'
        return true
      }
      return false
    },
    testPrices (price, addicionalValue, weightaddicionalValue, newRowElem) {
      /* Precio de lista (Obligatorio) */
      if (isNaN(price) || Number(price) < 0) {
        newRowElem._cellVariants.price = 'danger'
        return true
      }

      /* Valor adicional es un % y es obligatiorio */
      if (isNaN(addicionalValue) || Number(addicionalValue) < 0 || Number(addicionalValue) > 100) {
        newRowElem._cellVariants.addicionalValue = 'danger'
        return true
      }

      /* Precio por peso adicional (Obligatorio) */
      if (isNaN(weightaddicionalValue) || Number(weightaddicionalValue) < 0) {
        newRowElem._cellVariants.weightaddicionalValue = 'danger'
        return true
      }

      return false
    }
  },
  data () {
    return {
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 50, 70, 100, 1000],
      tabIndex: 0,
      success: false,
      inProgress: false,
      productsCount: 0,
      errorText: '',
      debugFileExtencion: '',
      delimiter: null,
      csvPricesFile: null,
      csvElements: [],
      csvFields: [
        { key: 'id', label: 'Id' },
        { key: 'zcFrom', label: 'CP desde' },
        { key: 'zcTO', label: 'CP hasta' },
        { key: 'weightFrom', label: 'Peso desde' },
        { key: 'weightTo', label: 'Peso hasta' },
        { key: 'price', label: 'Precio' },
        { key: 'addicionalValue', label: 'Valor adicional (%)' },
        { key: 'weightaddicionalValue', label: 'Valor adicional por peso' },
        { key: 'maxVolume', label: 'Volumen Máximo' },
        { key: 'deliveryWindow', label: 'Plazo de entrega' },
        { key: 'country', label: 'Pais' },
        { key: 'carrier', label: 'Transportadora' },
        { key: 'zcCommas', label: 'CP commas' }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>

  .overflow-x-auto {
    overflow-x: auto;
  }

  .b-form-file.custom-file {
    .custom-file-control[data-choose] {
      &::before {
          content: "Seleccionar" !important;
      }
    }
  }

  .fa-exclamation-triangle {
    color: #f8cb00;
    font-size: 20px;
    float: left;
    margin-right: 5px;
    display: inline-block;
  }

</style>



// WEBPACK FOOTER //
// src/components/carrier/AddPricesCSV.vue